import { ADD_ARTICLE,CHANGE_LANGUAGE } from "../constants/action-types";
const initialState = {
    articles: [],
    lang:localStorage.getItem('lang')
};

function rootReducer(state = initialState, action) {
    if (action.type === ADD_ARTICLE) {
        return Object.assign({}, state, {
          articles: state.articles.concat(action.payload)
        });
      }
      if(action.type === CHANGE_LANGUAGE)
      {
          console.log('state changing ... '+action.payload);
          state.lang = action.payload;
          localStorage.setItem('lang',action.payload);
      }
    return state;
}
export default rootReducer;